/**
 * The clips a rundown row sends to the playout, by kind: its own clip and the story's other video cues (ADR 086).
 * The row's cell shows an icon per kind, not the clips' names: 🎬 for a clip heard with its sound, VO for one the
 * presenter speaks over; both when the story holds both.
 */
export interface RowClipsLike {
  mediaAssetId: string | null;
  mediaVo: boolean;
  clips: ReadonlyArray<{ mediaAssetId: string; vo: boolean }>;
}

/** Every clip of the row, its own first. */
export const rowClipList = (it: RowClipsLike): Array<{ mediaAssetId: string; vo: boolean }> => [...(it.mediaAssetId ? [{ mediaAssetId: it.mediaAssetId, vo: it.mediaVo }] : []), ...it.clips];

/** Which kinds of clip the row carries. */
export function clipKinds(it: RowClipsLike): { sound: boolean; vo: boolean } {
  const all = rowClipList(it);
  return { sound: all.some((c) => !c.vo), vo: all.some((c) => c.vo) };
}

/** The cell: 🎬 for a sound clip, the VO tag for a VO clip, both when the row carries both. */
export const ClipIcons = ({ sound, vo }: { sound: boolean; vo: boolean }) => (
  <>
    {sound && <span className="clip-icon">🎬</span>}
    {vo && <span className="vo-tag">VO</span>}
  </>
);

/** The clips in words, for the cell's tooltip: `🎬 802 KIPRIAKO ARX · VO 801FONOSPARADOXH.ARX`. */
export const clipWords = (it: RowClipsLike, titles: ReadonlyMap<string, string>): string =>
  rowClipList(it)
    .map((c) => `${c.vo ? 'VO' : '🎬'} ${titles.get(c.mediaAssetId) ?? c.mediaAssetId}`)
    .join(' · ');
